import { render } from "./Banners.vue?vue&type=template&id=2829ab3c&scoped=true&ts=true"
import script from "./Banners.vue?vue&type=script&lang=ts"
export * from "./Banners.vue?vue&type=script&lang=ts"

import "./Banners.vue?vue&type=style&index=0&id=2829ab3c&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2829ab3c"]])

export default __exports__